export default __webpack_public_path__ + "static/media/Summary_of_Changes_to_Fidelity_Computer_Crime_Policy_October_2022.bfba75fe.pdf";